import React, { useState, useRef } from "react";
import { Tabs, Tab } from "react-bootstrap";
import CohortFiller from "./CohortPillar";
import "../../styles/CohortPillar.css";

const CohortButton = () => {
  const [activeKey, setActiveKey] = useState("pillars");

  const pillarRef = useRef(null);
  const tabsRef = useRef(null);

  const details = {
    pillars: {
      Mentorship:
        "Guided by industry leaders, WiSE provides mentorship in three formats to help women navigate challenges, gain clarity, and accelerate their growth in the semiconductor ecosystem. ",
      "Events and Meetups":
      "WiSE will host nine distinct types of events across both online and offline formats, designed to support learning, connection, and career growth. These include knowledge-sharing sessions, webinars, expert talks, and interactive forums led by industry leaders to spark dialogue, expand professional networks, and create meaningful community impact. Complementing our digital initiatives, WiSE’s in-person meetups and on-ground events foster authentic connections—encouraging collaboration, camaraderie, and a strong sense of belonging among women in the semiconductor ecosystem. ",
      Storytelling:
        "Every story matters. Through blogs, features, spotlights, and peer learning sessions, WiSE creates a platform for members to share their journeys, challenges, and lessons learned. Industry leaders also share their stories and experiences, offering real-world insights and inspiration. Together, these narratives enable members to learn from both peers and seasoned professionals—building perspective, confidence, and a strong sense of community across the semiconductor ecosystem. ",
      "Training and Projects":
        "From technical upskilling to leadership-focused workshops, WiSE training programs are designed to bridge the gap between academia and industry—equipping women with the skills and confidence needed for real-world success. Alongside this, hands-on projects and industry collaborations offer practical experience, opportunities to innovate, and platforms to showcase talent. Members can also apply to initiate their own projects; selected proposals receive structured guidance, mentorship, and support from WiSE to help turn ideas into impactful outcomes. ",
    },
    cohort: {
      Crawl: {
        years: "-2 to +2 years",
        description:
          "Designed for students and early learners, this cohort focuses on introducing the semiconductor ecosystem, core technical concepts, career pathways, and essential soft skills. It helps members transition from academic learning to industry readiness with clarity and confidence.",
      },
      "Climb and Consolidate": {
        years: "+2 to 7 years",
        description:
          "Tailored for women in their first few years of industry experience, this cohort emphasizes technical depth, workplace navigation, personal branding, and career direction.Members gain mentorship, peer learning, and exposure to real-world industry expectations.",
      },
      "Cultivate and Craft": {
        years: "7 to 15 years",
        description:
          "This cohort supports women looking to grow into senior technical or managerial roles. It focuses on leadership development, decision-making, visibility, cross-functional collaboration, and long-term career planning within the semiconductor ecosystem.",
      },
     "Command and Contribute": {
        years: "15+ years",
        description:
          "Created for experienced professionals and leaders, this cohort enables women to give back to the ecosystem through mentorship, storytelling, and strategic guidance. Members help shape the next generation while strengthening their own leadership presence and industry impact. ",
      },
      Comeback: {
        years: "Re-entry",
        description:
          "Designed for women who have taken a career break, the Comeback Cohort supports their transition back into the semiconductor and electronics industry. It focuses on skill refresh, confidence rebuilding, mentorship, and navigating re-entry challenges—helping women restart their careers with clarity, support, and renewed momentum. ",
      },
    },
    programs: {
      "Career Entrench":
        "Offline meetups and learning sessions for early-career professionals.",
      "Career Advance":
        "Mentorship to accelerate career progression.",
      "Career Coach":
        "Hands-on projects and real-world exposure.",
      "Campus to Career":
        "Bridging academics and industry.",
      Reignite:
        "Programs supporting career re-entry.",
    },
  };

  const handlePillarClick = () => {
    setActiveKey("cohort");

    setTimeout(() => {
      tabsRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100);
  };

  return (
    <div>
      {/* Heading + Pillar */}
      <div className="cohort-wrapper pt-0" ref={pillarRef}>
        <div className="cohort-header">
          <h1 className="cohort-heading">Cohort Structure</h1>
          <p className="cohort-subtitle">
            Empowering women through mentorship, innovation, and collaboration
            in the semiconductor industry.
          </p>
        </div>

        <CohortFiller onClick={handlePillarClick} />
      </div>

      {/* Tabs Section */}
      <div className="CohortTabs" ref={tabsRef}>
        <Tabs
          id="cohort-tabs"
          activeKey={activeKey}
          onSelect={(k) => setActiveKey(k)}
          className="mb-4"
          fill
        >
          <Tab eventKey="pillars" title="Pillars">
            <TabContent items={details.pillars} />
          </Tab>

          <Tab eventKey="cohort" title="Cohort">
            <TabContent items={details.cohort} />
          </Tab>

          {/* <Tab eventKey="programs" title="Programs">
            <TabContent items={details.programs} />
          </Tab> */}
        </Tabs>
      </div>
    </div>
  );
};

// Tab content renderer
const TabContent = ({ items }) => (
  <div className="tab-content-wrapper">
    {Object.entries(items).map(([title, data]) => {
      const isObject = typeof data === "object";

      return (
        <div key={title} className="tab-item">
          <h2 className="tab-title">
            {title}
            {isObject && data.years && (
              <span className="years-label"> ({data.years})</span>
            )}
          </h2>

          <p>{isObject ? data.description : data}</p>
        </div>
      );
    })}
  </div>
);

export default CohortButton;
